import Icon from '../components/Icon.vue'

Icon.register({
  'hand-scissors': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M216 440C216 417.9 233.9 400 256 400V392H224C201.9 392 184 374.1 184 352S201.9 312 224 312H256V304H48C21.5 304 0 282.5 0 256S21.5 208 48 208H256V194.4L78.4 124.7C53.8 115 41.6 87.1 51.3 62.5 61 37.8 88.9 25.6 113.6 35.3L303.9 110.1 328.8 79C341.1 63.6 362.7 59.5 379.8 69.3L491.8 133.3A40-40 0 0 0 512 168V408C512 426.6 499.2 442.7 481.2 446.9L345.2 478.9A40-40 0 0 0 336 480H256C233.9 480 216 462.1 216 440z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hand-scissors.js
// module id = DRte
// module chunks = 144